import { apiClient } from '@/api'

export default {
  namespaced: true,
  state: () => ({
    fields:[]
  }),
  mutations: {
    SET_CUSTOM_FIELDS(state, items) {
      state.fields = items
    }
  },
  actions: {
    async fetchCustomFields({ commit }, data) {
      const res = await apiClient('custom_fields.get', data)
      commit('SET_CUSTOM_FIELDS', res.list)
    },
    async saveCustomField({ commit }, data) {
      const res = await apiClient('custom_fields.create', data)
      commit('SET_CUSTOM_FIELDS', res.list)
    },
    async updateCustomField({ commit }, data) {
      const res = await apiClient('custom_fields.update', data)
      commit('SET_CUSTOM_FIELDS', res.list)
    },
    async deleteCustomField({ commit }, id) {
      const res = await apiClient('custom_fields.delete', { id })
      commit('SET_CUSTOM_FIELDS', res.list)
    },
    async updateSortCustomFields({ commit }, data) {
      const res = await apiClient('custom_fields.sort', data)
      commit('SET_CUSTOM_FIELDS', res.list)
    }
  }
}